@let ccgParses = (parseResults$ | async);
<div>
    <div ngbAccordion>
        @for (parse of ccgParses; track $index) {
        <div ngbAccordionItem>
            <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                    {{ parse.sentence }}
                </button>
            </h2>
            <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                    <ng-template>
                        <div class="d-flex flex-column gap-3 overflow-x-scroll">
                            @for (tree of parse.ccgTrees; track $index) {
                            <la-parse-tree-table [tree]="tree" />
                            }
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
        } @empty {
        <la-no-data dataType="parse" />
        }
    </div>
</div>
